// react
import React, { Component, PropTypes } from "react"
// material-ui
import { Card, CardActions, CardHeader, CardText } from "material-ui/Card"
// app
import Edit from "components/common/buttons/Edit"
import SaveCancel from "components/common/buttons/SaveCancel"
import TextField from "components/common/TextField"


const initialState = {
    edit: false,
    other: ""
}

class Other extends Component {
    constructor(props) {
        super(props)
        this.state = initialState

        this.edit = () => this.setState({ edit: true })
        this.cancel = () => this.setState(initialState)
        
        this.save = this.save.bind(this)
        this.handleOtherChange = this.handleOtherChange.bind(this)
    }

    save() {
        const { other } = this.state

        this.props.onSave({
            id: this.props.person.get("id"),
            other
        })

        this.setState(initialState)
    }

    handleOtherChange(other) {
        this.setState({ other })
    }

    render() {
        const displayOther = []
        let other = this.props.person.get("other", "")
        let i = 0

        if (other === null) other = ""
        if (typeof other !== "string") other = ""

        other.split("\n").forEach(other => {
            displayOther.push(
                <div key={ i++ }>{ other }</div>
            )
        })

        return (
            <Card className="card">
                <CardHeader
                    title="Other Qualifications"
                    style={{ paddingBottom: 0 }}
                />
                <CardText>
                    { this.state.edit ?
                        <TextField
                            label="Please describe any relevant other qualifications you might have"
                            rows={ 7 }
                            multiLine={ true }
                            maxlength={ 500 }
                            value={ this.props.person.get("other", "") }
                            onChange={ this.handleOtherChange }
                        />
                        :
                        displayOther
                    }
                </CardText>
                <CardActions>
                    { this.state.edit ?
                        <SaveCancel
                            onSave={ this.save }
                            onCancel={ this.cancel }
                        />
                        :
                        <Edit onEdit={ this.edit } />
                    }
                </CardActions>
            </Card>
        )
    }
}

Other.propTypes = {
    person: PropTypes.object.isRequired, // immutable.Map()
    onSave: PropTypes.func.isRequired
}

export default Other


/** WEBPACK FOOTER **
 ** ./src/components/person/Other/person-other.js
 **/